export default {
  id: 18,
  title: 'Target #18 - Matrix',
  url: 'https://cssbattle.dev/play/18',
  colors: ['#5C434C', '#F09462', '#F5D6B4'],
  solution:
    '<a><style>body{background:#5c434c}a{position:fixed;top:10;left:10;width:80;height:80;background:#f09462;border-radius:100% 0 0;box-shadow:100px 0 #f5d6b4,200px 0 #f09462,300px 0 #f5d6b4,0 100px #f5d6b4,100px 100px #f09462,200px 100px #f5d6b4,300px 100px #f09462,0 200px #f09462,100px 200px #f5d6b4,200px 200px #f09462,300px 200px #f5d6b4}</style>',
}
